import { User } from '@awork/features/user/models/user.model'
import { Task } from '@awork/features/task/models/task.model'

interface ITaskSchedule {
  id: string
  user: User
  userId?: string
  startDate: Date
  endDate: Date
  task: Task
  taskId?: string
  updatedOn: Date

  columnOrder?: number
  indentation?: number
  totalColumns?: number
  extraSpacing?: boolean
}

export class TaskSchedule implements ITaskSchedule {
  id: string
  user: User
  userId?: string
  startDate: Date
  endDate: Date
  task: Task
  taskId?: string
  updatedOn: Date

  columnOrder?: number
  indentation?: number
  totalColumns?: number
  extraSpacing?: boolean

  constructor(taskSchedule: Partial<ITaskSchedule>) {
    Object.assign(this, taskSchedule)

    if (typeof taskSchedule.startDate === 'string') {
      this.startDate = new Date(taskSchedule.startDate)
    }

    if (typeof taskSchedule.endDate === 'string') {
      this.endDate = new Date(taskSchedule.endDate)
    }

    if (taskSchedule.task) {
      this.task = new Task(taskSchedule.task)
    }

    if (taskSchedule.user) {
      this.user = new User(taskSchedule.user, 'TaskSchedule')
    }
  }

  get duration(): number {
    return (this.endDate.getTime() - this.startDate.getTime()) / 1000
  }

  /**
   * Checks that the start date and end date and duration for the task schedule are valid
   * @returns {boolean}
   */
  get isValid(): boolean {
    return this.duration >= 0
  }
}
